import { StepProps } from "~/components/organisms/step";
import { chargepointDetailsSchema } from "~/schemas/apis/chargepoint-details";
import { ChargepointType } from "~/schemas/forms/chargepoint";
import { tryCatch } from "./try-catch";

export function initIndexState(): number {
  const savedFormData = sessionStorage.getItem("formData");
  if (!savedFormData) return 0;

  const formData = JSON.parse(savedFormData);

  if (!formData.chargepoint || !Array.isArray(formData.chargepoint)) return 0;

  if (formData.chargepoint[0].serialNumber) return formData.chargepoint.length;

  return 0;
}

export function initNumConnectorsState(): number {
  const savedFormData = sessionStorage.getItem("formData");
  if (!savedFormData) return 0;

  const formData = JSON.parse(savedFormData);
  if (!formData.chargepoint || !Array.isArray(formData.chargepoint)) return 0;

  const connectors = formData.chargepoint.reduce(
    (sum: number, chargepoint: ChargepointType) => {
      return sum + chargepoint.connectors;
    },
    0
  );

  return connectors;
}

export function isDuplicateChargepoint(
  chargepoints: ChargepointType[],
  serialNumber: string
) {
  return chargepoints.some(
    (chargepoint: ChargepointType) => chargepoint.serialNumber === serialNumber
  );
}

export async function fetchChargepointDetails(serialNumber: string) {
  const result = await tryCatch(
    fetch(`/api/chargepoint/details?serialnumber=${serialNumber}`)
  );

  if (result.error) {
    console.error("Error fetching charge point details:", result.error);
    throw result.error;
  }

  return await result.data.json();
}

export function formatChargepointData(data: unknown): ChargepointType {
  if (!data) throw new Error("No data found");

  const parsedItem = chargepointDetailsSchema.parse(data);
  if (!parsedItem) throw new Error("Error parsing data");

  return {
    iccidWithLuhn: parsedItem.chargePointIccid,
    serialNumber: parsedItem.chargePointIdentifier,
    model: parsedItem.chargePointModel,
    connectors: Number(parsedItem.numConnectors),
    maxPower: parsedItem.chargePointMaxPower,
    hasSim: !!parsedItem.chargePointIccid,
    addSim: false,
  };
}

export function updateChargepointValues(
  data: ChargepointType,
  index: number,
  setValue: StepProps["setValue"]
) {
  setValue(`chargepoint.${index}.iccidWithLuhn`, data.iccidWithLuhn);
  setValue(`chargepoint.${index}.serialNumber`, data.serialNumber);
  setValue(`chargepoint.${index}.model`, data.model);
  setValue(`chargepoint.${index}.connectors`, data.connectors);
  setValue(`chargepoint.${index}.maxPower`, data.maxPower);
  setValue(`chargepoint.${index}.hasSim`, !!data.iccidWithLuhn);
}
